exports.components = {
  "component---src-pages-events-tsx": () => import("./../../../src/pages/events.tsx" /* webpackChunkName: "component---src-pages-events-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-news-tsx": () => import("./../../../src/pages/news.tsx" /* webpackChunkName: "component---src-pages-news-tsx" */),
  "component---src-pages-not-found-tsx": () => import("./../../../src/pages/NotFound.tsx" /* webpackChunkName: "component---src-pages-not-found-tsx" */),
  "component---src-templates-event-detail-tsx": () => import("./../../../src/templates/event-detail.tsx" /* webpackChunkName: "component---src-templates-event-detail-tsx" */)
}

